export default __webpack_public_path__ + "static/media/Задания с пользой для города.b76754db.jpg";